import * as reactQuery from '@tanstack/react-query';

import {
  ActivityAnalyzeV1ControllerReportActivityAnalyzeVariables,
  ActivityAnalyzeV1ControllerReportActivityAnalyzeError,
  fetchActivityAnalyzeV1ControllerReportActivityAnalyze,
} from 'generated/apiComponents';
import { useApiContext } from 'generated/apiContext';
import type * as Schemas from 'generated/apiSchemas';

/**
 * Hook to use the POST method as a useQuery and not as a mutation
 * It should be a get but we need to pass params as a body to not hit the
 * URL size limit.
 *
 * window.fetch does not allow to provide a body for GET methods
 */
export const useActivityAnalyzeV1ControllerReportActivityAnalyzeQuery = <
  TData = Schemas.GetReportActivityAnalyzeV1ResponseDto,
>(
  variables: ActivityAnalyzeV1ControllerReportActivityAnalyzeVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.GetReportActivityAnalyzeV1ResponseDto,
      ActivityAnalyzeV1ControllerReportActivityAnalyzeError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { fetcherOptions, queryOptions } = useApiContext(options);
  return reactQuery.useQuery<
    Schemas.GetReportActivityAnalyzeV1ResponseDto,
    ActivityAnalyzeV1ControllerReportActivityAnalyzeError,
    TData
  >({
    queryKey: [
      '/v1/report-analyze/activity-analyze',
      'productionAnalyzeV1ControllerReportProductionAnalyze',
      variables,
    ],
    queryFn: ({ signal }) =>
      fetchActivityAnalyzeV1ControllerReportActivityAnalyze(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
};
